// Use the local logo placed in public/ so it's available at /logomyrv1.svg
const localLogo = "/logomyrv1.svg";

function NavbarLogo(/* darkMode not required when using single file */) {
  const styles = {
    height: "16px", // altura exata em pixels solicitada
    width: "auto",
    display: "block",
  };

  return <img src={localLogo} style={styles} alt="Myr Logo" />;
}

export default NavbarLogo;
